import {createSelector} from 'reselect'
import selectorsGenerator from '../hierarchyAssignmentsPanelTab/selectorsGenerator'
import {showEditor} from '../createUserManagementAssignmentsEditor/selectors'
import {getManagementAssignmentsSelection as getUserDataManagementAssignmentsSelection} from '../../../panels/user/userData/selectors'

const getCreateManagementAssignmentsPanelState = state => state.userManagement.createManagementAssignmentsPanel
const hierarchyAssignmentsPanelTabSelectors = selectorsGenerator(getCreateManagementAssignmentsPanelState)

export const getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId

export const getTab = hierarchyAssignmentsPanelTabSelectors.getTab

export const getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds

export const getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds

export const getCustomerIds = hierarchyAssignmentsPanelTabSelectors.getCustomerIds

export const getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch

export const isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen

export const loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs

export const getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters

export const getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters

export const getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName

export const selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskMaEntities

export const selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectMaEntities

export const selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities

export const isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading

export const isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded

export const getManagementAssignmentsSelection = state => getUserDataManagementAssignmentsSelection(state)

export const isShown = state => getCreateManagementAssignmentsPanelState(state).isShown

export const isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities

export const isNeedToLoadData = createSelector(
    isShown,
    isLoaded,
    getTab,
    loadedTabs,
    showEditor,
    (show, loaded, tab, loadedTabs, showEditor) => show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false
)

export const getEntirelyAssignedTasksCounter = createSelector(
    getTaskIds,
    getCounters,
    (ids, counters) => {
        return counters.tasks.curValue - ids.length
    }
)

export const getEntirelyAssignedProjectCounter = createSelector(
    getProjectIds,
    getCounters,
    (ids, counters) => {
        return counters.projects.curValue - ids.length
    }
)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/selectors.js